var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCameraOff(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.9584 19.7917C23.9584 20.3442 23.7389 20.8741 23.3482 21.2648C22.9575 21.6555 22.4276 21.875 21.8751 21.875H3.12508C2.57255 21.875 2.04264 21.6555 1.65194 21.2648C1.26124 20.8741 1.04175 20.3442 1.04175 19.7917V8.33333C1.04175 7.7808 1.26124 7.25089 1.65194 6.86019C2.04264 6.46949 2.57255 6.25 3.12508 6.25H7.29175L9.37508 3.125H15.6251L17.7084 6.25H21.8751C22.4276 6.25 22.9575 6.46949 23.3482 6.86019C23.7389 7.25089 23.9584 7.7808 23.9584 8.33333V19.7917Z",
    stroke: "#656565",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5001 17.7083C14.8013 17.7083 16.6667 15.8429 16.6667 13.5417C16.6667 11.2405 14.8013 9.375 12.5001 9.375C10.1989 9.375 8.33342 11.2405 8.33342 13.5417C8.33342 15.8429 10.1989 17.7083 12.5001 17.7083Z",
    stroke: "#656565",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCameraOff);
export default __webpack_public_path__ + "static/media/camera-off.050481e52b6c109d882d974794120f38.svg";
export { ForwardRef as ReactComponent };